import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// import firstpagebackground from "../Assets/firstpagebackground.jpg";
import firstpagebackground from "../../../../Assets/vendor/firstpagebackground.jpg";

const languages = [
    { id: "en", title: "English", subtitle: "English" },
    { id: "hi", title: "हिंदी", subtitle: "Hindi" },
    { id: "mr", title: "मराठी", subtitle: "Marathi" },
    { id: "kn", title: "ಕನ್ನಡ", subtitle: "Kannada" },
    // Add more languages as needed
];

export default function FirstTimeLoginPage() {
    const [selectedLang, setSelectedLang] = useState("en");
    const navigate = useNavigate();

    const handleConfirm = () => {
        // console.log("Language selected:", selectedLang);
        navigate('/estimated-earnings')
        // proceed to next step or save selection
    };

    return (
      <div className="font-satoshi min-h-screen h-screen bg-black text-white flex flex-col ">
            {/* Image Section */}
            <div className="relative w-full  flex-1 ">
                <img
                    src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vendor/firstpagebackground.jpg'// Replace with your image path or import
                    alt="Swiggy partner"
                    className="w-full h-full object-contain"
                />
                {/* Top Welcome Section */}
                <div className="  absolute top-8 left-0 w-full text-center z-10 bg-[radial-gradient(white, transparent)]">
                    <h1 className="text-2xl text-[#00bdff] font-bold">Hello Partner!</h1>
                    {/* <p className=" text-[#00bdff] text-md">Welcome to Claimpro</p> */}
                </div>
            </div>


            {/* Language Selection Section */}
            <div className="bg-white w-full rounded-t-xl px-6 pt-6 pb-[1.5rem] text-black">
                <h2 className="text-md text-center font-semibold mb-2">Welcome To <span className='text-[#00bdff]'>Claimpro</span></h2>

              

                <button
                    onClick={handleConfirm}
                    className="mt-[1rem] w-full bg-[#00bdff] text-white py-3 rounded-xl font-semibold text-lg"
                >
                    Continue
                </button>
            </div>
        </div>
    );
}
